const CartItemImageArteFinal = ({ onClick = null, styleContainer = null, styleImg = null, img, height, width }) => {
  return (
    <div
      className="image-wrapper"
      style={{
        ...styleContainer,
      }}
      onClick={onClick}
    >
      {
        <img
          src={img ? img : '/Image_not_available.png'}
          alt="img"
          // placeholder={<ImageCartSpinner height={height} width={width} />}
          style={{
            ...styleImg,
          }}
        />
      }
      {/* {!loadedImgAAFF && !img && <ImageCartSpinner height={height} width={width} />} */}
    </div>
  );
};

export default CartItemImageArteFinal;
